import { render } from "./FilterGudang.vue?vue&type=template&id=1bbe6fce"
import script from "./FilterGudang.vue?vue&type=script&lang=js"
export * from "./FilterGudang.vue?vue&type=script&lang=js"
script.render = render

export default script